<script>
/**
 * Register component
 */
export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
      isRegisterError: false,
      registerSuccess: false
    };
  },
  props: {
    submitUrl: {
      type: String,
      required: true
    },
    regError: {
      type: String,
      required: false,
      default: () => null
    }
  },
  mounted() {
    this.isRegisterError = !!this.regError;
  },
  methods: {
    passwordEyeToggle() {
      var x = document.getElementById("password");
      var y = document.getElementById("eye-1");
      var z = document.getElementById("eye-2");
      
      if(x.type === "password"){
        x.type = "text";
        y.style.display = "block";
        z.style.display = "none";
      }
      else{
        x.type = "password";
        y.style.display = "none";
        z.style.display = "block";     
      }
    },
    confirmPasswordEyeToggle() {
      var x = document.getElementById("password-confirm");
      var y = document.getElementById("eye-3");
      var z = document.getElementById("eye-4");
      
      if(x.type === "password"){
        x.type = "text";
        y.style.display = "block";
        z.style.display = "none";
      }
      else{
        x.type = "password";
        y.style.display = "none";
        z.style.display = "block";     
      }
    },
  }
};
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">
      <div class="card overflow-hidden">
        <div class="bg-soft-primary">
          <div class="row">
            <div class="col-7">
              <div class="text-primary p-4">
                <h5 class="text-primary">Free Register</h5>
                <p>Get your free Skote account now.</p>
              </div>
            </div>
            <div class="col-5 align-self-end">
              <img src="/images/profile-img.png" alt class="img-fluid" />
            </div>
          </div>
        </div>
        <div class="card-body pt-0">
          <div>
            <a href="/">
              <div class="avatar-md profile-user-wid mb-4">
                <span class="avatar-title rounded-circle bg-light">
                  <img src="/images/logo.svg" alt class="rounded-circle" height="34" />
                </span>
              </div>
            </a>
          </div>

          <b-alert
            v-model="registerSuccess"
            class="mt-3"
            variant="success"
            dismissible
          >Registration successfull.</b-alert>

          <b-alert v-model="isRegisterError" class="mt-3" variant="danger" dismissible>{{regError}}</b-alert>

          <b-form class="p-2" :action="submitUrl" method="POST">
              <slot />
            <b-form-group id="email-group" label="Name" label-for="name">
              <b-form-input
                id="name"
                v-model="name"
                name="name"
                type="text"
                placeholder="Enter name"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="fullname-group" label="Email" label-for="email">
              <b-form-input
                id="email"
                name="email"
                v-model="email"
                type="email"
                placeholder="Enter email"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="password-group" label="Password" label-for="password">
              <b-form-input
                id="password"
                v-model="password"
                name="password"
                type="password"
                placeholder="Enter password"
              ></b-form-input>
              <span class="eye-mask1" >
                <i class="fa fa-eye" aria-hidden="true" @click="passwordEyeToggle()" id="eye-1"> </i>
                <i class="fa fa-eye-slash" aria-hidden="true" @click="passwordEyeToggle()" id="eye-2"> </i>
              </span>
            </b-form-group>
            <b-form-group label="Confirm Password" label-for="password-confirm">
              <b-form-input
                id="password-confirm"
                v-model="password_confirmation"
                name="password_confirmation"
                type="password"
                placeholder="Confirm password"
              ></b-form-input>
              <span class="eye-mask2" >
                <i class="fa fa-eye" aria-hidden="true" @click="confirmPasswordEyeToggle()" id="eye-3"> </i>
                <i class="fa fa-eye-slash" aria-hidden="true" @click="confirmPasswordEyeToggle()" id="eye-4"> </i>
              </span>
            </b-form-group>

            <div class="mt-4">
              <b-button type="submit" variant="primary" class="btn-block">Register</b-button>
            </div>

            <div class="mt-4 text-center">
              <p class="mb-0">
                By registering you agree to the Skote
                <a
                  href="javascript: void(0);"
                  class="text-primary"
                >Terms of Use</a>
              </p>
            </div>
          </b-form>
        </div>
        <!-- end card-body -->
      </div>
      <!-- end card -->

      <div class="mt-5 text-center">
        <p>
          Already have an account ?
          <a href="/login" class="font-weight-medium text-primary">Login</a>
        </p>
        <p>
          © {{ new Date().getFullYear() }} Skote. Crafted with
          <i class="mdi mdi-heart text-danger"></i> by Themesbrand
        </p>
      </div>
    </div>
    <!-- end col -->
  </div>
</template>

<style lang="scss" module>

.eye-mask1{
  display: flex;
  position: absolute; 
  top: 408px;
  right: 40px;
  cursor: pointer;
}
.eye-mask2{
  display: flex;
  position: absolute; 
  top: 485px;
  right: 40px;
  cursor: pointer;
}
#eye-1{
  display: none;
}
</style>
